<template>  
  <div class="landing_container">
    <SideBar/>
    <SimpleProgressBar :elements="section_elements"/>
    <MainScreen/>
    <WaveAnimation wave_order="main-page"/>
    <Section :pin="section_elements[0].ref" color="dark-blue" :wave="false">
      <div class="design_wrapper">
        <img class="fresh-water" src="https://static.igem.wiki/teams/4185/wiki/freshwater.png" alt="">
        <h2 class="major_text"> is a <p class="active bold">scarce</p> resource. </h2>
        <!-- <div class="primary_stat_text">
          <h1>3%</h1>
          <h2>of all water on Earth is <p class="active bold">fresh water</p></h2>
        </div>
        <h2 class="major_text"> <p class="active bold">Only 1%</p> of it is available for <p class="active bold">human use, </p> and the rest are stored in ice caps and glaciers. </h2> -->
      </div>
    </Section>
    <!-- <Section :pin="section_elements[0].ref" color="dark-blue" :wave="false">
      <div class="design_wrapper">
        <img class="fresh-water" src="https://static.igem.wiki/teams/4185/wiki/freshwater.png" alt="">
        <img class="is-scarce-resource" src="https://static.igem.wiki/teams/4185/wiki/is-a-scarce-resource.png" alt="">
      </div>
    </Section> -->
    <Section :pin="section_elements[1].ref" color="dark-blue" :wave="false">
      <div class="design_wrapper">
        <img class="water-ray" src="https://static.igem.wiki/teams/4185/wiki/ray-icon-water-level.png" alt="">
        <div class="primary_stat_text">
          <h1>3%</h1>
          <h2>of all water on Earth is <p class="active bold">fresh water</p></h2>
        </div>
        <h2 class="major_text"> <p class="active bold">Only 1%</p> of it is available for <p class="active bold">human use, </p> and the rest are stored in ice caps and glaciers. </h2>
      </div>
    </Section>
    <Section :pin="section_elements[2].ref" color="dark-blue" :wave="false">
      <div class="design_wrapper" style="height: 80vh">
        <h2 class="major_text">The available fresh water is <p class="active bold">not sufficient</p> to satisfy increasing demand. This leads to various issues such as:</h2>
        <div class="icon_container first_wide">
          <div class="icon_wrap">
            <img src="https://static.igem.wiki/teams/4185/wiki/icon-increase-igem.png" alt="">
            <h1 class="text">Increasing number of <p class="active bold">avoidable deaths</p> </h1>
          </div>
          <div class="icon_wrap">
            <img src="https://static.igem.wiki/teams/4185/wiki/icon-lost-opportunity-igem.png" alt="">
            <h1 class="text"><p class="active bold">Missed opportunities </p> for development <p class="active bold"></p></h1>
          </div>
          <div class="icon_wrap">
            <img src="https://static.igem.wiki/teams/4185/wiki/icon-agri-igem.png" alt="">
            <h1 class="text">High economic <p class="active bold">losses</p> in affected fields</h1>
          </div>
        </div>
      </div>
    </Section>
    <Section :pin="section_elements[3].ref" :color="this.desalination_color" :wave="this.desalination_wave">
      <div id="desalination-fadeout" class="design_wrapper">
        <h2 class="major_text">Where can we find more fresh water?</h2>
        <div class="shard_container">
          <img class="shard" src="https://static.igem.wiki/teams/4185/wiki/salt1.png" alt=""/>
          <img class="shard" src="https://static.igem.wiki/teams/4185/wiki/salt2.png" alt=""/>
          <img class="shard" src="https://static.igem.wiki/teams/4185/wiki/salt3.png" alt=""/>
          <img class="shard" src="https://static.igem.wiki/teams/4185/wiki/salt4.png" alt=""/>
          <img class="shard" src="https://static.igem.wiki/teams/4185/wiki/salt5.png" alt=""/>
        </div>
      </div>
      <div id="desalination-fadein" class="design_wrapper hidden no-display">
        <h1 style="font-weight: bold;" class="major_text">Desalination of </h1>
        <img class="sea-water" src="https://static.igem.wiki/teams/4185/wiki/seawater.png" alt="">
        <a href="#ref4"><img id="arrow" class="secondary-arrow arrow-pulsate-animation" src="https://static.igem.wiki/teams/4185/wiki/arrow-igem-home.png" alt=""></a>
      </div>
    </Section>
    <Section v-if="this.primary_visible[0].state" :pin="section_elements[4].ref" color="light-blue" :wave="false">
      <div class="design_wrapper">
        <h2 class="major_text dark">Current desalination of sea water relies on established methods such as reverse osmosis</h2>
        <h2 class="major_text dark bold">But these methods are...</h2>
        <div class="icon_container">
            <div class="icon_wrap">
              <img src="https://static.igem.wiki/teams/4185/wiki/icon-factory.png" alt="">
              <h1 class="text dark">Fossil fuel dependent</h1>
            </div>
            <div class="icon_wrap">
              <img src="https://static.igem.wiki/teams/4185/wiki/icon-expensive.png" alt="">
              <h1 class="text dark">Expensive</h1>
            </div>
            <div class="icon_wrap">
              <img src="https://static.igem.wiki/teams/4185/wiki/icon-loss-of-habitat.png" alt="">
              <h1 class="text dark">Destroying Habitats</h1>
            </div>
          </div>
      </div>
    </Section>
    <Section v-if="this.primary_visible[1].state" :pin="section_elements[5].ref" :color="solution_color" :wave="solution_wave">
      <div id="solution-fadeout" class="design_wrapper full_width">
        <h1 class="major_text light bold">Our solution?</h1>
      </div>
      <div id="solution-fadein" class="design_wrapper full_width hidden no-display">
        <h1 class="major_text bold light-blue">Biodesalination</h1>
      </div>
    </Section>
    <Section v-if="this.secondary_visible[0].state" :pin="section_elements[6].ref" color="white" :wave="false">
      <div class="design_wrapper">
        <h2 class="major_text">The available fresh water is <p class="active bold">not sufficient</p> to satisfy increasing demand. This leads to various issues.</h2>
        <!-- <video muted="muted" id="video-pumps" width="420">
          <source src="../../assets/img/Landing/sodium-chloride-pump-animation.mp4" type="video/mp4">
          Your browser does not support HTML video.
        </video> -->
        <img class="animation" src="https://static.igem.wiki/teams/4185/wiki/sodium-chloride-pump-animation.gif" alt="">
        <h2 class="major_text">The addition of a green light activated <p class="active">cloride pump</p> and <p class="active">sodium antiporters</p> to the cells membrane allows for water desalination</h2>      
      </div>
    </Section>
    <Section v-if="this.secondary_visible[1].state" :pin="section_elements[7].ref" color="white" :wave="false">
      <div class="design_wrapper">
        <h2 class="major_text">Our bacteria are immobalized in alginate beads to be upt into salt water for desalination.</h2>
        <!-- <video muted="muted" id="video-alginate" width="420">
          <source src="https://static.igem.wiki/teams/4185/wiki/alginate-bead-animation.gif" type="video/mp4">
          Your browser does not support HTML video.
        </video> -->
        <img class="animation" src="https://static.igem.wiki/teams/4185/wiki/alginate-bead-animation.gif" alt="">
        <h2 class="major_text">This creates an easy to use for industry and the chances of contaminating the water with baceteria.</h2>      
      </div>
    </Section>
    <Section v-if="this.secondary_visible[2].state" :pin="section_elements[8].ref" color="white" :wave="false">
      <div class="design_wrapper">
        <div class="image_wrapper">
            <img class="salt-water-beads" src="https://static.igem.wiki/teams/4185/wiki/salt-water-beads.png" alt="">
            <img class="horiontal_arrow" src="https://static.igem.wiki/teams/4185/wiki/arrow-igem-home-horizontal.png" alt="">
            <img class="fresh-water-beads" src="https://static.igem.wiki/teams/4185/wiki/fresh-water-beads.png" alt="">
          </div>
        <h2 class="major_text">With these techniques, we aim to convert sea water into fresh water for agriculture and industrial use via biodesalination.</h2>      
      </div>
    </Section>
    <Section v-if="this.secondary_visible[3].state" :pin="section_elements[9].ref" color="white" :wave="false">
      <div class="design_wrapper">
        <img class="aestuarium-last" src="https://static.igem.wiki/teams/4185/wiki/logo-slogan.png" alt="">
      </div>
    </Section>
  <Footer/>
</div>
</template>

<script>
import WaveAnimation from '../../components/WaveAnimation.vue'
import Section from '../../components/Section.vue'
import SideBar from '@/components/SideBar.vue'
import MainScreen from '@/components/MainScreen.vue'
import SimpleProgressBar from '../../components/SimpleProgressBar.vue'

export default {
  name: 'App',
  components: {
    MainScreen, WaveAnimation, Section, SideBar, SimpleProgressBar
  },
  data () {
    return {
      // play_video: false,
      show_desalination_page: false,
      desalination_wave: 'dark-blue-on-dark-blue',
      desalination_color: 'dark-blue',

      show_solution_page: false,
      solution_wave: 'light-blue-on-light-blue',
      solution_color: 'light-blue',
      primary_visible: [
        {
          id: 0,
          state: false
        },
        {
          id: 1,
          state: false
        }
      ],
      secondary_visible: [
        {
          id: 0,
          state: false
        },
        {
          id: 1,
          state: false
        },
        {
          id: 2,
          state: false
        },
        {
          id: 3,
          state: false
        }
      ],
      section_elements: [
        {
          id: 0,
          name: '',
          ref: 'start',
          type: 'dark'
        },
        {
          id: 1,
          name: '',
          ref: 'ref1',
          type: 'dark'
        },
        {
          id: 2,
          name: '',
          ref: 'ref2',
          type: 'dark'
        },
        {
          id: 3,
          name: '',
          ref: 'ref3',
          type: 'dark'
        },
        {
          id: 4,
          name: '',
          ref: 'ref4',
          type: 'light'
        },
        {
          id: 5,
          name: '',
          ref: 'ref5',
          type: 'light'
        },
        {
          id: 6,
          name: '',
          ref: 'ref6',
          type: 'light'
        },
        {
          id: 7,
          name: '',
          ref: 'ref7',
          type: 'light'
        },
        {
          id: 8,
          name: '',
          ref: 'ref8',
          type: 'light'
        },
        {
          id: 9,
          name: '',
          ref: 'ref9',
          type: 'light'
        }
      ]
    }
    
  },
  mounted () {
    window.addEventListener('scroll', this.fadeInOut);
  },
  methods: {
    disableScroll () {
      document.body.classList.add("stop-scrolling");
      window.addEventListener('touchmove', this.preventDefault);
    },
    enableScroll () {
      document.body.classList.remove("stop-scrolling");
      window.removeEventListener('touchmove', this.preventDefault);
    },
    fadeInOut() {
      // let screen_height_half = window.innerHeight / 4
      let desalination_anchor = document.getElementById(this.section_elements[3].ref);
      let fadeinDesalinaton = document.getElementById('desalination-fadein')
      let fadeuotDesalinaton = document.getElementById('desalination-fadeout')

      let solution_anchor = document.getElementById(this.section_elements[5].ref);
      let fadeinSolution = document.getElementById('solution-fadein')
      let fadeuotSolution = document.getElementById('solution-fadeout')

      const screen_height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      // For desalination part
      var distInView = desalination_anchor.getBoundingClientRect().top - 5 - 0.2*screen_height;
      if (distInView < 0) {
        if (!this.show_desalination_page) {
          this.disableScroll()
          setTimeout(() => { 
            fadeuotDesalinaton.classList.add('fade-out')
            this.desalination_wave = 'light-blue-on-dark-blue'
            this.desalination_color = 'light-blue'
          }, 1000)

          setTimeout(() => { 
            fadeuotDesalinaton.classList.add('no-display')
            fadeinDesalinaton.classList.remove('no-display')
          }, 1250) // Timout + animation duration

          setTimeout(() => {
            fadeinDesalinaton.classList.add('fade-in')

            this.primary_visible.forEach((item) => {
              item.state = true
            });
          }, 1500)

          this.enableScroll()
          this.show_desalination_page = true
        }
      }

      // For solution Section
      if (solution_anchor) {
        distInView = solution_anchor.getBoundingClientRect().top - 5 - 0.2*screen_height;
        if (distInView < 0) {
          if (!this.show_solution_page) {
            this.disableScroll()
            setTimeout(() => { 
              fadeuotSolution.classList.add('fade-out')
              this.solution_wave = 'white-on-light-blue'
              this.solution_color = 'white'
            }, 1000)

            setTimeout(() => { 
              fadeuotSolution.classList.add('no-display')
              fadeinSolution.classList.remove('no-display')
            }, 1250) // Timout + animation duration


            setTimeout(() => {
              fadeinSolution.classList.add('fade-in')

              this.secondary_visible.forEach((item) => {
                item.state = true
              });
            }, 1500)

            this.enableScroll()
            this.show_solution_page = true
          }
        }
      }

      // Check pump video playback

      // let video_anchor_pumps = document.getElementById(this.section_elements[6].ref)
      // let video_element_pumps = document.getElementById('video-pumps')

      
      // if (video_anchor_pumps) {
      //   distInView = video_anchor_pumps.getBoundingClientRect().top - 5;
      //   let distInViewBottom = video_anchor_pumps.getBoundingClientRect().bottom + 5

      //   // console.log(video_anchor.clientHeight)
      //   // console.log(video_anchor.getBoundingClientRect().bottom)
      //   // Video is in view
      //   if (distInView < video_anchor_pumps.clientHeight / 2 && distInViewBottom > video_anchor_pumps.clientHeight / 2) {
      //     if (video_element_pumps.paused) {
      //       video_element_pumps.play()
      //     }
      //   }else {
      //     // console.log('not in view')
      //     if (!video_element_pumps.paused) {
      //       video_element_pumps.pause()
      //     }
      //   }
      // }

      // Check Alginate Video Playback
      // let video_anchor_alginate = document.getElementById(this.section_elements[7].ref)
      // let video_element_alginate = document.getElementById('video-alginate')

      
      // if (video_anchor_alginate) {
      //   distInView = video_anchor_alginate.getBoundingClientRect().top - 5;
      //   let distInViewBottom = video_anchor_alginate.getBoundingClientRect().bottom + 5

      //   // console.log(video_anchor.clientHeight)
      //   // console.log(video_anchor.getBoundingClientRect().bottom)
      //   // Video is in view
      //   if (distInView < video_anchor_alginate.clientHeight / 2 && distInViewBottom > video_anchor_alginate.clientHeight / 2) {
      //     if (video_element_alginate.paused) {
      //       video_element_alginate.play()
      //     }
      //   }else {
      //     // console.log('not in view')
      //     if (!video_element_alginate.paused) {
      //       video_element_alginate.pause()
      //     }
      //   }
      // }

      

      // if (myVideo.paused) 
      //   myVideo.play(); 
      // else 
      //   myVideo.pause();


          // else {
            // elem.classList.add("in-display");
          // }
      // }
    },
    // fadeIn() {
    //   let fadein = document.querySelector(".fade-in");

    //   for (var i = 0; i < fadein.length; i++) {
    //       var elem = fadein[i]
    //       var distInView = elem.getBoundingClientRect().top - window.innerHeight + 20;
    //       if (distInView < 0) {
    //         // elem.classList.add("in-display");
    //       } else {
    //         // elem.classList.remove("in-display");
    //       }
    //   }
    // },
    // randomShardPosition (increment) {

    //   // Math.floor(Math.random() * (max - min + 1)) + min;
    //   let randomLeft, randomBottom

    //   if (increment % 2 == 0) {
    //     randomLeft = Math.floor(Math.random() * (45 -  + 1)) + 5;
    //     randomBottom = Math.floor(Math.random() * (95 - 5 + 1)) + 5;
    //   } else {
    //     randomLeft = Math.floor(Math.random() * (95 - 5 + 1)) + 5;
    //     randomBottom = Math.floor(Math.random() * (95 - 5 + 1)) + 5;
    //   }



    //   return randomLeft, randomBottom
    // },
    // instantiateShards () {
    //   this.shards = []

      // var increment = 0;
      // var drops = "";

      // while (increment < 0) {
        //couple random numbers to use for various randomizations
        //random number between 5 and 1
        // let shard_type = (Math.floor(Math.random() * (5 - 1 + 1))) + 1;
        //random number between 5 and 2
        // var randoFiver = (Math.floor(Math.random() * (5 - 2 + 1) + 2));

        // Math.floor(Math.random() * (max - min + 1)) + min;
        // let randomLeft = Math.floor(Math.random() * (90 - 10 + 1)) + 10;
        // let randomBottom = Math.floor(Math.random() * (90 - 10 + 1)) + 10;

        //increment
        // increment += 1;

        // let shard_src = `../../assets/img/Landing/Shards/Shard${shard_type}.png`
        //add in a new raindrop with various randomizations to certain CSS properties
        // this.shards += '<img class="shard" src="../../assets/img/Landing/Shards/Salt1.png" alt="">'
        // this.shards.push({id: increment, type: shard_type, left: randomLeft, bottom: randomBottom})
      // }
    // }
  }
}
</script>


<style lang="scss">
  @import '@/assets/scss/main.scss';

  .secondary-arrow  {
    // left: 45%;
    // position: absolute;
    // top: 80%;
    cursor: pointer;
    z-index: 2;
    width: 20%;
    margin: 0 auto;
  }

  .shard_container {
    display: flex;
    padding-top: 35%;
    position: relative;
    justify-content: center;

    .shard {
      width: 15%;
      position: relative;

      &:nth-child(1) {
        // right: 100px;

        animation: floating-forward 1.5s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
      }

      &:nth-child(2) {
        // top: 50px;

        animation: floating-backward 1.5s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
      }

      &:nth-child(3) {
        // top: 90px;

        animation: floating-forward 1.5s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
      }

      &:nth-child(4) {
        // top: 130px;
        animation: floating-backward 1.5s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
      }

      &:nth-child(5) {
        // top: 110px;
        animation: floating-forward 1.5s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
      }
      // position: absolute;
    }
  }

  .design_wrapper {
    text-align: center;
    flex-direction: column;
    display: flex;
    width: 80%;
    transition: opacity 2s linear 1s;
    margin: 0 auto;
    justify-content: space-evenly;

    .animation {
      margin: 0 auto;
      width: 35%;
    }

    &.hidden {
      opacity: 0;
    }

    &.no-display {
      display: none;
    }

    &.full_width {
      width: fit-content;
    }

    .major_minor_container {
      position: relative;
      background: $light-blue-color;
    }

    .image_wrapper {
      display: flex;
      justify-content: center;
      align-items: center;

      img:nth-child(1) {
        width: 20%;
      }

      img:nth-child(2) {
        width: 10%;
        margin: 0 5%;
      }

      img:nth-child(3) {
        width: 20%;
      }

    }

    .icon_container {
      display: flex;
      flex-direction: row;
      align-content: center;
      align-items: center;
      justify-content: space-around;
      flex-wrap: wrap;

      .icon_wrap {
        color: white;
        text-align: center;
        width: 33%;
        
        .text.dark {
          color: $dark-blue-color;
          font-weight: bold;
        }

        &.first_wide {
          &:nth-child(1) {
            width: 100vw;
          }
        }

        &.last_wide {
          &:nth-child(3) {
            width: 100vw;
          }
        }

        img {
          max-width: 80%;
          height: 180px;
          margin: 0 20px;
          object-fit: contain;
        }

        .text {
          width: 76%;
          text-align: center;
          margin: 0 auto;
          font-size: 1.6rem;
        }
      }
    }

    .primary_stat_text {
      margin-top: 10px;
      margin-bottom: 40px;

      h1 {font-size: 10vh; font-weight: bold; color: $accent-color}
    }

    h1.major_text {
      font-size: 4em;
      // width: 70%;
      margin: 5% auto;


      &.dark {
        color: $dark-blue-color;
      }

      &.light-blue {
        color: $light-blue-color;
      }

      &.light {
        color: #fff;
      }

      &.active {
        color: $accent-color;
        background: none;
      }

      &.hide {
        opacity: 0;
      }

      &.bold {
        font-weight: bold;
      }
    }


    h2.major_text {
      // font-size: 2em;
      font-size: 4vh;
      width: 70%;
      margin: 5% auto;

      &.dark {
        color: $dark-blue-color;
      }

      &.light-blue {
        color: $light-blue-color;
      }

      &.light {
        color: #fff;
      }

      &.hide {
        opacity: 0;
      }

      &.bold {
        font-weight: bold;
      }
    }

    .fresh-water {
      max-width: 70%;
      object-fit: contain;
      margin: 0 auto;
    }

    .is-scarce-resource {
      max-width: 30%;
      object-fit: contain;
      margin: 0 auto;
    }

    .water-ray {
      max-width: 30%;
      object-fit: contain;
      margin: 0 auto;
    }

    .sea-water {
      width: 80%;
      margin: 0 auto;
    }

    .aestuarium-last {
      width: 90%;
      margin: 0 auto;
    }

    .salt-water-beads {
      width: 20%;
    }

    .horiontal_arrow {
      width: 20%;
    }

    .fresh-water-beads {
      width: 20%;
    }
}
</style>



